module.exports = __webpack_public_path__ + "dojo.2haHBrtt.svg";